import React from 'react';
import {FaCheck} from "react-icons/fa";
import {FaCircleXmark, FaTriangleExclamation} from "react-icons/fa6";

const DevicesAppCellRenderer = ({data, authorized, dt_activation}) => {
    const statusIcon = () => {
        if (data.type !== "CELULAR") return;

        if (authorized) {
            return dt_activation ?
                <FaCheck color={"#198754"} title={`Ativado em ${new Date(dt_activation).toLocaleDateString()}`}/> :
                <FaTriangleExclamation color={"#ed9c28"} title="Pendente de ativação"/>
        }

        return (
            <FaCircleXmark color={"dc4c64"} title={"Não autorizado"}/>
        )
    }

    return (
        <div className={"flex items-center justify-center h-full w-full"}>
            {statusIcon()}
        </div>
    );
};

export default DevicesAppCellRenderer;